/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：95__part-1
 */

"use strict"

var r
import * as /* [auto-meaningful-name] */Module_11 from /* 11 */"./11"
import * as /* [auto-meaningful-name] */Src_editor_widget_builtIn_types from /* 5 */"../../../../src/editor/widget/built-in/types"
var /* [auto-meaningful-name] */IconWidgetInput = "icon-widget-input"
var /* [auto-meaningful-name] */_148cefff = "#148cefff"
var /* [auto-meaningful-name] */C1c1c1 = "#c1c1c1"
var /* [auto-meaningful-name] */_333333 = "#333333"
var /* [auto-meaningful-name] */_5DC5FB = "#5DC5FB"
var d = 280
var p = 48
var f = 40
var h = 20
var /* [auto-meaningful-name] */Fb1919ff = "#fb1919ff"
var g = false
var _ = false
var /* [auto-meaningful-name] */SansSerif = "sans-serif"
var b = 14
var /* [auto-meaningful-name] */Https__static$bcmcdn$com_coco_image_defaultInputBackground$png = "https://static.bcmcdn.com/coco/image/default-input-background.png"
r = {}
Module_11.a(r, Src_editor_widget_builtIn_types.s.SMALL, {
  fontSize: 14,
  minWidth: 44,
  maxWidth: 360,
  height: 32
})
Module_11.a(r, Src_editor_widget_builtIn_types.s.MEDIUM, {
  fontSize: 16,
  minWidth: 56,
  maxWidth: 360,
  height: 48
})
Module_11.a(r, Src_editor_widget_builtIn_types.s.LARGE, {
  fontSize: 18,
  minWidth: 78,
  maxWidth: 360,
  height: 60
})
var E = r
export { IconWidgetInput as a }
export { _148cefff as s }
export { C1c1c1 as c }
export { _333333 as l }
export { _5DC5FB as u }
export { d }
export { p }
export { f }
export { h }
export { Fb1919ff as m }
export { g }
export { _ }
export { SansSerif as v }
export { b }
export { Https__static$bcmcdn$com_coco_image_defaultInputBackground$png as y }
export { E }
export default IconWidgetInput
